<template>
  <div class="frisbuy-summary-widget__tags">
    <div
      v-for="(tag, index) in props.tags"
      class="frisbuy-summary-widget__tag"
      :key="index"
    >
      {{ tag }}
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{ tags: Array<string> }>();
</script>
